import type { RequestInterceptorFn } from '../types';

export interface HeadersRequestInterceptorOptions {
  /** 返回要注入的 headers，值为 undefined 时跳过该 key */
  getHeaders: () =>
    | Record<string, string | undefined>
    | Promise<Record<string, string | undefined>>;
}

export const createHeadersRequestInterceptor = (
  options: HeadersRequestInterceptorOptions,
): RequestInterceptorFn => {
  return async config => {
    const headers = await options.getHeaders();
    for (const [key, value] of Object.entries(headers)) {
      if (value !== undefined) {
        config.headers.set(key, value);
      }
    }
    return config;
  };
};
